import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        SET_USER_INFO(state, info) {
            state.userInfo = info
            localStorage.setItem('userInfo', JSON.stringify(info))
        },
        CLEAR(state) {
            state.token = ''
            state.userInfo = {}
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
        }
    },
    actions: {
        login({ commit }, { token, userInfo }) {
            commit('SET_TOKEN', token)
            commit('SET_USER_INFO', userInfo)
        },
        logout({ commit }) {
            commit('CLEAR')
        }
    },
    getters: {
        isLoggedIn: state => !!state.token
    }
})
